"use strict";

/* eslint-disable react/jsx-handler-names, react/no-find-dom-node, react/no-string-refs */
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var Ribbon =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Ribbon, _React$Component);

  function Ribbon(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Ribbon);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Ribbon).call(this, props));
    var events = ['onMouseDown', 'onDrag', 'onDragEnd', 'pointMoveTo', '_setHuePosition'];
    events.forEach(function (e) {
      if (_this[e]) {
        _this[e] = _this[e].bind((0, _assertThisInitialized2.default)(_this));
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Ribbon, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('mouseup', this.onDragEnd);
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      e.preventDefault();
      var x = e.clientX;
      var y = e.clientY;
      this.pointMoveTo({
        x: x,
        y: y
      });
      window.addEventListener('mousemove', this.onDrag);
      window.addEventListener('mouseup', this.onDragEnd);
    }
  }, {
    key: "onDrag",
    value: function onDrag(e) {
      var x = e.clientX;
      var y = e.clientY;
      this.pointMoveTo({
        x: x,
        y: y
      });
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd(e) {
      var x = e.clientX;
      var y = e.clientY;
      this.pointMoveTo({
        x: x,
        y: y
      });
      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('mouseup', this.onDragEnd);
    }
  }, {
    key: "measureBounds",
    value: function measureBounds() {
      return _reactDom.default.findDOMNode(this).getBoundingClientRect();
    }
  }, {
    key: "pointMoveTo",
    value: function pointMoveTo(coords) {
      var rect = this.measureBounds();
      var width = rect.width;
      var left = coords.x - rect.left;
      left = Math.max(0, left);
      left = Math.min(left, width);
      var huePercent = left / width;
      var hue = Math.floor(huePercent * 360);
      this.props.onChange({
        hue: hue
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          hue = _this$props.hue;
      var per = hue / 360 * 100;
      return _react.default.createElement("div", {
        className: (0, _classNames.default)('private-react-colorpicker--ribbon', 'private-react-colorpicker--slider', className)
      }, _react.default.createElement("span", {
        ref: "point",
        style: {
          left: per + "%"
        }
      }), _react.default.createElement("div", {
        className: "private-react-colorpicker--handler",
        onMouseDown: this.onMouseDown
      }));
    }
  }]);
  return Ribbon;
}(_react.default.Component);

exports.default = Ribbon;
Ribbon.propTypes = {
  className: _react.PropTypes.string,
  hue: _react.PropTypes.number,
  onChange: _react.PropTypes.func
};
module.exports = exports.default;